@if (props$ | async; as props) {
  <section [style]="sectionStyles">
    @if (labelEnabled) {
      <blaze-element-label
        [color]="props?.style?.general?.title?.color1"
        [extendInputPadding]="elementContext?.extendInputPadding"
        [fontFamily]="props?.style?.labelBlock?.fontFamily"
        [fontSize]="props?.style?.labelBlock?.fontSize"
        [fontStyle]="props?.style?.labelBlock?.fontStyle"
        [fontWeight]="props?.style?.labelBlock?.fontWeight"
        [horizontalAlign]="props?.content?.title?.align"
        [icon]="props?.content?.title?.icon"
        [iconColor]="props?.content?.title?.iconColor?.color1"
        [iconPosition]="props?.content?.title?.iconPosition"
        [iconSize]="props?.style?.labelBlock?.iconSize"
        [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
        [lineHeight]="props?.style?.labelBlock?.lineHeight"
        [position]="props?.content?.title?.position"
        [tooltip]="props?.content?.title?.tooltip"
        [width]="props?.content?.title?.width"
      >
        {{ labelText }}
      </blaze-element-label>
    }
    <div class="images-placeholder" [style]="imagePlaceholderStyles">
      <div
        (dragleave)="draggingOver = false"
        (dragover)="addButtonVisible && allowDrop($event)"
        (drop)="addButtonVisible && drop($event)"
        (scroll)="updateListScroll($event)"
        [class.dragging-over]="draggingOver"
        [class.omit-border]="isStaticImageSource || isReadOnly"
        [class.validation-error]="hasValidationError"
        [style]="imageUploadZoneStyles"
        class="image-upload-zone blaze-virtual-scrollable"
      >
        @if (showUploader && !isReadOnly) {
          <div class="upload-hint">
            <div class="hint">
              Drop image to upload, or&nbsp;<a blazeClickable (click)="fileInput.click()">browse</a>
            </div>
            <div class="extensions">{{ supportedExtensions }}</div>
          </div>
        }
        @if (showUploader && isReadOnly) {
          <div class="upload-hint">
            @if (props.content.options && props.content.options.emptyThumbnail === 'custom-text') {
              <div class="hint">{{ props.content.options.emptyText }}</div>
            } @else {
              <mat-icon
                class="image-empty-state"
                [svgIcon]="getEmptyImageUrl(props.content.options.emptyThumbnail)"
              />
            }
          </div>
        }
        @for (imageUrl of imageUrls; track imageUrl; let i = $index) {
          @if (imageUrl) {
            <img
              (click)="emitClick(false, i)"
              [alt]="props?.content?.options?.altText"
              [class.cursor-pointer]="isClickActionAllowed"
              [class.snap-end]="!invisiblePagination"
              [src]="imageUrl"
              [style]="imageStyles"
              class="image"
              imgError
              loading="lazy"
            />
          }
        }
      </div>
      @if (!invisiblePagination && imageUrls.length > 1) {
        <div class="pagination" [style]="imagePaginationStyles">
          @let currentImageDisplayIndex = currentImageDisplayIndex$ | async;
          @for (image of imageUrls; track $index; let i = $index) {
            <div class="pagination-indicator" [class.active]="currentImageDisplayIndex === i"></div>
          }
        </div>
      }
    </div>
    @if (addButtonVisible) {
      <button
        (click)="fileInput.click()"
        blazeIconButton
        blazeIconButtonSize="md"
        class="add-button"
      >
        <mat-icon svgIcon="icon_add_32" />
      </button>
    }
    <input
      #fileInput
      (change)="fileSelected($event.target)"
      [accept]="acceptedExtensions"
      [multiple]="uploadLimit !== 1"
      class="hidden"
      type="file"
    />
  </section>
}
@if (hasValidationError) {
  <div class="validation" [style]="validationStyles">
    {{ formState?.messages?.required || formState?.messages?.invalid || '' }}
  </div>
}
